import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import useEventListener from 'hooks/useEventListener';

/**
 * Returns an event handler that executes the callback only if the
 * event's target is outside of, or equal to the provided excluded element
 *
 * @param {object} excludedElementRef - A React ref (as obtained from `useRef` or `createRef`) to an element that should be excluded from triggering the `onClick` callback
 * @param {Function} callback - Function that's called when the event originated outside of the excluded element
 */

export function getOutsideTargetCallback(excludedElementRef, callback) {
  return function (event) {
    var excludedRefs = Array.isArray(excludedElementRef) ? excludedElementRef : [excludedElementRef];
    var _iterator = _createForOfIteratorHelper(excludedRefs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ref = _step.value;
        var excludedElement = ref === null || ref === void 0 ? void 0 : ref.current;

        // Bail out if the clicked element or the currently focused element
        // is inside of excludedElement. We need to check the focused element
        // to prevent an issue in Chrome where initiating a drag inside of an
        // input (to select the text inside of it) and ending that drag outside
        // of the input fires a click event, breaking our excludedElement rule.
        if (excludedElement && (excludedElement === event.target || excludedElement === document.activeElement || excludedElement.contains(event.target) || excludedElement.contains(document.activeElement))) {
          return null;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    callback(event);
  };
}

/**
 * Handle clicks that occur outside of the element provided in the first parameter
 *
 * @param {object} excludedElementRef - A React ref (as obtained from `useRef` or `createRef`) to an element that should be excluded from triggering the `onClick` callback
 * @param {Function} onClick - Function that's called when a click occurs outside of the excluded element
 * @param {bool} [isEnabled=true] - Set to false to disable the hook
 */

function useOnClickOutside(excludedElementRef, onClick, isEnabled) {
  useEventListener('click', getOutsideTargetCallback(excludedElementRef, onClick), {
    isEnabled: isEnabled
  });
}
export default useOnClickOutside;